import { call, put, select } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { AddRequestAction, DeleteRequestAction, UpdateRequestAction } from '../../types/strapiGOS';
import { addDataGOS, deleteData, extractStrapiData, updateDataGOS } from '../../api/api';
import { addDataGOSFailure, addDataGOSSuccess, deleteDataGOSFailure, deleteDataGOSSuccess, setLastAddedId, setLastDocId, updateDataGOSFailure, updateDataGOSSuccess } from './actions';
import { fetchData } from '../filterData/actions';

export function* addDataGOSSaga(action: AddRequestAction) {
  const { modelName, data, creatorId } = action.payload;
  try {
    const response: AxiosResponse<any> = yield call(addDataGOS, modelName, data);
    const extractedData = extractStrapiData(response);
    yield put(addDataGOSSuccess(modelName, extractedData, creatorId));
    yield put(setLastAddedId(modelName, extractedData.id));
    if (extractedData.documentId) {
      yield put(setLastDocId(modelName, extractedData.documentId));
    }
  } catch (error) {
    const errorMessage = (error as any)?.message || '';
    yield put(addDataGOSFailure(modelName, errorMessage));
  }
}

export function* addDataSuccessGOSSaga(action: AddRequestAction) {
  const { modelName } = action.payload;
  yield put(fetchData(modelName));
}

export function* updateDataGOSSaga(action: UpdateRequestAction) {
  const { modelName, documentId, data } = action.payload;
  try {
    const response: AxiosResponse<any> = yield call(updateDataGOS, modelName, documentId, data);
    const extractedData = extractStrapiData(response);
    yield put(updateDataGOSSuccess(modelName, extractedData));
    // if (modelName === 'GOS-inconsistencies' && extractedData.IdGOSactions) {
    //   yield new Promise(resolve => setTimeout(resolve, 100));
    //   const inconsistencies: any[] = yield call(fetchInconsistenciesByActionId, extractedData.IdGOSactions);
    //   yield put(fetchInconsistenciesByActionIdSuccess(inconsistencies));
    // }
  } catch (error) {
    const errorMessage = (error as any)?.message || '';
    yield put(updateDataGOSFailure(modelName, errorMessage));
  }
}

export function* deleteDataGOSSaga(action: DeleteRequestAction) {
  const { modelName, documentId } = action.payload;
  try {
    yield call(deleteData, modelName, documentId);
    yield put(deleteDataGOSSuccess(modelName, documentId));
    // if (modelName === 'GOS-inconsistencies') {
    //   const state: any = yield select();
    //   const inconsistencies = state.GOSStrapi.formAddActions['GOS-inconsistencies']?.data || [];
    //   if (inconsistencies.length > 0 && inconsistencies[0].IdGOSactions) {
    //     const actionId = inconsistencies[0].IdGOSactions;
    //     yield new Promise(resolve => setTimeout(resolve, 100));
    //     const updatedInconsistencies: any[] = yield call(fetchInconsistenciesByActionId, actionId);
    //     yield put(fetchInconsistenciesByActionIdSuccess(updatedInconsistencies));
    //   }
    // }
  } catch (error) {
    const errorMessage = (error as any)?.message || '';
    yield put(deleteDataGOSFailure(modelName, errorMessage));
  }
}

